export default __webpack_public_path__ + "static/media/Raj Salwan.ccdff93a.jpg";